<!--
DashboardEmailLog.vue

Static/demo version.

Purpose:
- Display a read-only feed of recent "Email Properties" activity
- Reassure users that shortlist emails are being sent
- Provide visibility into who sent what, when, and to whom

Future implementation notes:
- Replace static `emailLogs` with Vuex-backed data
- Source data from backend email activity/audit log
- Filter activity by type: "email_shortlist_sent"
- This card should remain informational only (no actions)
-->

<template>
  <div class="card dashboard-card">
    <div class="card-header">
      <div>
        <h4 class="mb-0">Email Properties Log (demo)</h4>
        <small class="text-muted">Recent shortlist emails sent</small>
      </div>
    </div>

    <div class="card-body">
      <div v-if="!emailLogs.length" class="text-muted">
        No email activity yet.
      </div>

      <div v-else class="log-list">
        <div v-for="log in emailLogs" :key="log.id" class="log-item">
          <div class="log-main">
            <div class="log-title">
              {{ log.user }}
            </div>

            <div class="log-meta">
              Sent shortlist ({{ log.propertyCount }} properties)
            </div>

            <div class="log-recipient">To: {{ log.recipient }}</div>
          </div>

          <div class="log-side">
            <div class="log-time">
              {{ log.time }}
            </div>

            <span class="status-pill" :class="`status-pill--${log.status}`">
              {{ log.statusLabel }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DashboardEmailLog",

  data() {
    return {
      // Static/demo data only
      emailLogs: [
        {
          id: 1,
          time: "10:42 AM",
          user: "Tex Walker",
          recipient: "buyer@email.com",
          propertyCount: 4,
          status: "queued",
          statusLabel: "Queued"
        },
        {
          id: 2,
          time: "09:58 AM",
          user: "Alec Stimson",
          recipient: "client@example.com",
          propertyCount: 2,
          status: "sent",
          statusLabel: "Sent"
        },
        {
          id: 3,
          time: "Yesterday",
          user: "Cam Da Man",
          recipient: "investor@domain.com",
          propertyCount: 6,
          status: "sent",
          statusLabel: "Sent"
        },
        {
          id: 4,
          time: "Yesterday",
          user: "Tim Yabut",
          recipient: "test@invalid.com",
          propertyCount: 3,
          status: "failed",
          statusLabel: "Failed"
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.dashboard-card {
  height: 100%;
}

.log-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 320px;
  overflow-y: auto;
}

.log-item {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 10px 12px;
  background: #fff;
}

.log-main {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.log-title {
  font-weight: 600;
  font-size: 13px;
}

.log-meta {
  font-size: 12px;
  color: #374151;
}

.log-recipient {
  font-size: 12px;
  color: #6b7280;
}

.log-side {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
  white-space: nowrap;
}

.log-time {
  font-size: 11px;
  color: #6b7280;
}

.status-pill {
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 999px;
  border: 1px solid transparent;
}

.status-pill--queued {
  background: #fff7ed;
  color: #9a3412;
  border-color: #fed7aa;
}

.status-pill--sent {
  background: #ecfdf5;
  color: #065f46;
  border-color: #a7f3d0;
}

.status-pill--failed {
  background: #fef2f2;
  color: #991b1b;
  border-color: #fecaca;
}
</style>
